import { instance } from "libs/api";

import { ApiRoutesEarnings } from "../../constants";
import { EarningsQuantitiesResponse } from "./earningsQuantities.types";

export const requestEarningsQuantities =
  async (): Promise<EarningsQuantitiesResponse> => {
    return await instance.get(ApiRoutesEarnings.EarningsQuantities);
  };
